class TelemetryService {
  providers = [];
  properties = {};

  constructor(providers = [], initialProperties = {}) {
    // `telemetryConfig` comes from the JADE template in a global var
    const isTelemetryEnabled = window.telemetryConfig.isTelemetryEnabled;
    this.providers = isTelemetryEnabled ? providers : [];
    this.properties = initialProperties;
  }

  info(title = "", properties = {}) {
    const newProperties = { ...this.properties, ...properties };
    this.providers.forEach((provider) => {
      provider.info(title, newProperties);
    });
  }

  error(title = "", properties = {}) {
    const newProperties = { ...this.properties, ...properties };
    this.providers.forEach((provider) => {
      provider.error(title, newProperties);
    });
  }
}

export default TelemetryService;



// WEBPACK FOOTER //
// ./client/src/telemetry/telemetryService.js